import { useState } from "react";

export default function Gallery({ images, name }: { images: string[]; name: string }) {
  const [active, setActive] = useState(0);

  const go = (i: number) => setActive((i + images.length) % images.length);

  return (
    <div className="flex flex-col gap-3">
      <div className="relative h-[300px] w-full overflow-hidden rounded-lg bg-background-100 md:h-[440px]">
        <img
          src={images[active]}
          alt={`${name} 图片 ${active + 1} - 美味的快递`}
          title={`${name} - 美味的快递美食外卖`}
          className="h-full w-full object-top"
        />
        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(active - 1)}
          className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-background-200 bg-background-50/90 text-foreground-800 transition hover:bg-background-50"
        >
          <i className="ri-arrow-left-s-line text-xl" />
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(active + 1)}
          className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-background-200 bg-background-50/90 text-foreground-800 transition hover:bg-background-50"
        >
          <i className="ri-arrow-right-s-line text-xl" />
        </button>
        <span className="absolute bottom-3 right-3 rounded-full bg-black/50 px-3 py-1 text-xs font-medium text-white">
          {active + 1} / {images.length}
        </span>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {images.map((img, i) => (
          <button
            key={img}
            type="button"
            onClick={() => setActive(i)}
            className={`h-20 w-full overflow-hidden rounded-lg border-2 transition md:h-24 ${
              active === i ? "border-primary-500" : "border-transparent opacity-80 hover:opacity-100"
            }`}
          >
            <img src={img} alt={`${name} 缩略图 ${i + 1}`} className="h-full w-full object-top" />
          </button>
        ))}
      </div>
    </div>
  );
}